import queries from '@apis/queries';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/css';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { OrderLine as OrderItemProps } from '@models/order';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    item: OrderItemProps;
}

function OrderItem({ item }:Props) {
    const {
        itemName, quantity, personalOptions, defaultOptions, itemImageUrl, totalAmount, shopItemId,
    } = item;
    const { t } = useTranslation('order');
    const { data: itemDetail } = useQuery(queries.items.detail(shopItemId));
    const options = [...personalOptions, ...defaultOptions]
        .map((optionGroup) => optionGroup.options)
        .flat();
    const optionNames = options
        .map((option) => `${option.optionName}(${option.quantity}${t('items.optionCount')})`)
        .sort().join(' | ');
    const priceUnit = usePriceUnit();
    const globalItemName = useGlobalName({
        name: itemName,
        nameJa: itemDetail?.nameJa,
        nameEn: itemDetail?.nameEn,
    });
    return (<Row className={styles.container}
        spacing={16}
        fullWidth>
        <div className={styles.img}>
            <Image src={itemImageUrl}
                width={100}
                height={100}
                alt={t('items.imageAlt')} />
        </div>
        <Column spacing={2} fullWidth className={styles.text}>
            <Text size='lg' fontWeight='bold' color={colors.gray6}
                className={styles.name} >
                {globalItemName}
            </Text>
            <Row spacing={8} className={styles.dotWrapper}>
                <Text>{quantity}{t('items.optionCount')}</Text>
                <div className={styles.dot} />
                <Text>{totalAmount.toLocaleString()}{priceUnit}</Text>
            </Row>
            <Text>
                {optionNames}
            </Text>
        </Column>
    </Row>
    );
}

export default OrderItem;
